<template>
  <div class="modal recipe-edit" v-bind:class="{ 'is-active': recipe }">
    <div class="modal-background" v-on:click="$emit('close')"></div>
    <div class="modal-content">
      <div class="box">
        <form v-on:submit.prevent="save">
          <div class="field">
            <label class="label">{{ $t("Name") }}</label>
            <div class="control">
              <input
                class="input recipe-edit--input-name"
                type="text"
                v-model="editedRecipe.name"
                :placeholder="$t('Pancakes')"
              />
            </div>
          </div>
          <div class="field">
            <div class="control">
              <label class="label">{{ $t("Ingredients") }}</label>
              <textarea
                rows="8"
                class="textarea recipe-edit--textarea-ingredients"
                v-model="ingredientLines"
                :placeholder="$t('placeholder-ingredients')"
              >
              </textarea>
            </div>
          </div>
          <div class="field">
            <div class="control">
              <input
                type="submit"
                :value="$t('Save')"
                class="button is-primary recipe-edit--save-button"
              />
            </div>
          </div>
        </form>
      </div>
    </div>
    <button
      class="modal-close is-large"
      aria-label="close"
      v-on:click="$emit('close')"
    ></button>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "RecipeEdit",
  props: ["recipe"],
  data: function () {
    return {
      editedRecipe: { ...this.recipe },
      ingredientLines: this.recipe.ingredients.join("\n"),
    };
  },
  methods: {
    save: function () {
      this.editedRecipe.name = this.editedRecipe.name.trim();
      this.editedRecipe.ingredients = this.ingredientLines
        .split("\n")
        .map((name) => name.trim())
        .filter((name) => name !== "");
      this.$store.dispatch("saveRecipe", this.editedRecipe).then(() => {
        this.$emit("close");
      });
    },
  },
  watch: {
    recipe: function (newRecipe) {
      this.editedRecipe = { ...newRecipe };
      this.ingredientLines = newRecipe.ingredients.join("\n");
    },
  },
});
</script>

<style scoped>
.modal-content {
  max-height: 100vh;
}

.modal-close {
  background-color: rgba(10, 10, 10, 0.3);
}
</style>
<i18n>
  {
    "en": {
      "placeholder-ingredients": "Flour\nEggs\nMilk"
    },
    "de": {
      "Pancakes": "Pfannkuchen",
      "placeholder-ingredients": "Mehl\nEier\nMilch",
      "Name": "Name",
      "Ingredients": "Zutaten"
    }
  }
</i18n>
